import React, { useEffect, useState } from 'react';
// import { useJsonApi } from '../../../../services/GlobalStore/GlobalStore';
import useAuthenticate from '../../../../hooks/useAuthenticate';
import FlightComponent from '../FlightComponent';
import { jsonApiAxios, useHandleError } from '../../../../services/api';

const FlightsPage = (props: any) => {
  const {
    setFlightsToSave,
    setFlightsFound,
    errorReason = '',
    tripsArray = [],
  } = props;
  const [tripFlights, setTripFlights] = useState([]);
  const { token } = useAuthenticate();
  const [handleError] = useHandleError();

  // const { data: flightsData } = useJsonApi(
  //   `/subscriptionTrips/${tripId}`,
  //   {
  //     cachePolicy: 'no-cache',
  //     queryParams: {
  //       include: [
  //         'allSubscriptionFlights.airline',
  //         'allSubscriptionFlights.departureAirport',
  //         'allSubscriptionFlights.arrivalAirport',
  //         'subscriptionBillingCycle',
  //       ].join(),
  //     },
  //     headers: { Authorization: `Bearer ${token}` },
  //   },
  //   []
  // );

  useEffect(() => {
    const fetchTrips = async () => {
      try {
        const promises = tripsArray.map(itemId =>
          jsonApiAxios.get(
            `/subscriptionTrips/${itemId}?include=allSubscriptionFlights.airline,allSubscriptionFlights.departureAirport,allSubscriptionFlights.arrivalAirport,subscriptionBillingCycle`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )
        );

        const results = await Promise.all(promises);
        setTripFlights(results);
      } catch (error) {
        handleError(error);
      }
    };

    fetchTrips();
  }, [token]);

  useEffect(() => {
    if (tripFlights?.length && setFlightsFound) {
      setFlightsFound(tripFlights);
    }
  }, [tripFlights?.length]);

  return (
    <div>
      {tripFlights?.length &&
      tripFlights[0]?.all_subscription_flights?.length ? (
        <FlightComponent
          data={tripFlights.flatMap(
            item => item.all_subscription_flights || []
          )}
          addFlight={true}
          setFlightsToSave={setFlightsToSave}
          errorReason={errorReason}
          subscriptionBillingCycle={tripsArray[0]?.subscription_billing_cycle}
        />
      ) : null}
    </div>
  );
};

export default FlightsPage;
